import { Box, Anchor, Text } from "grommet";
import { Tooltip } from "@material-ui/core";
import OfflineBoltIcon from "@material-ui/icons/OfflineBolt";
import WarningIcon from "@material-ui/icons/Warning";
import { ReactComponent as Logo } from "../../assets/umc-utrecht-logo.svg";

export interface HeaderProps {
  isModelLoaded: boolean;
  backendType?: string;
  breakpoint: string;
}

export function HeaderArea({ isModelLoaded, backendType, breakpoint }: HeaderProps): React.ReactElement {
  return (
    <Box
      gridArea="header"
      fill="horizontal"
      pad={{ vertical: "small" }}
      direction={breakpoint === "bigEnough" ? "row" : "column"}
      justify="between"
      align="center"
    >
      <Box width="189px" align="start">
        <Logo width="150" height="80" />
      </Box>
      {isModelLoaded && (
        <Box>
          {backendType == "webgl" ? (
            <Box>
              <Tooltip title="Using the WebGL GPU backend for the fastest experience.">
                <OfflineBoltIcon color="primary" />
              </Tooltip>
            </Box>
          ) : (
            <Box direction="column" align="center">
              <WarningIcon color="secondary" />
              <Text style={{ color: "#f50057" }}>
                No GPU found on this computer. Unfortunately, this tool is usually too slow to work without a GPU due to complicated models
                used. Please try again on a different computer.
              </Text>
            </Box>
          )}
        </Box>
      )}
      <Box>
        <Text textAlign={breakpoint === "bigEnough" ? "end" : "center"}>
          Made by{" "}
          <Anchor href="https://www.linkedin.com/in/rutger-v-9846b8173/" target="_blank">
            Rutger van de Leur
          </Anchor>{" "}
          <br />
          &amp;{" "}
          <Anchor href="http://linkedin.com/in/max-bos/" target="_blank">
            Max Bos
          </Anchor>
        </Text>
      </Box>
    </Box>
  );
}
